import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const ProtectedRoute = ({
  children,
  requiredRole = null,
  requireAdmin = false,
  requireSuperAdmin = false,
}) => {
  const { user, isAuthenticated, loading, isInitialized } = useContext(AuthContext);
  const location = useLocation();

  // Show loading state while authentication is being checked
  if (loading || !isInitialized) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login with return path
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If super admin access is required, only allow is_superuser
  if (requireSuperAdmin && !user?.is_superuser) {
    return <Navigate to="/" replace />;
  }

  // If admin access is required, allow is_superuser OR org admin (role === "admin")
  if (requireAdmin && !user?.is_superuser && user?.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // If role check is required
  if (requiredRole && (!user.role || user.role !== requiredRole)) {
    // User doesn't have required role, redirect to home or unauthorized page
    return <Navigate to="/" replace />;
  }

  // If authenticated and passes role check, render the children or outlet
  return children ? children : <Outlet />;
};

export default ProtectedRoute;